export default __webpack_public_path__ + "static/media/06.2dff639e.jpg";